<div *ngIf="initialized">
  <div class="card mb-0">
    <div>
      <header class="card-header bg-light py-3 px-5">
        <div class="d-flex justify-content-between align-items-center">
          <h3 class="mb-0">Add Workout to Calendar</h3>

          <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('cancel')">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </header>
      <div class="card-body">
        <form id="form" (ngSubmit)="onSave()" [formGroup]="formGroup" novalidate>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="form-control-label" for="workoutName">
                  Workout:
                </label>
                {{workoutName}}
              </div>
            </div>
            <div class="col-md-8">
              <div class="form-group">
                <label class="form-control-label" for="workoutDate">
                  Workout Date
                </label>
                <kendo-datepicker placeholder="" class="form-control" formControlName="workoutDate"></kendo-datepicker>
                <div class="invalid-message">
                  <div>Workout Date is required</div>
                </div>
              </div>
            </div>
          </div>
      </form>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col">
            <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('cancel')">Cancel</button>
          </div>
          <div class="col text-right">
            <button form="form" type="submit" [promiseBtn]="submitComplete" class="btn btn-primary">Add to Calendar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

